export default {
    namespaced: true,
    state: {
        electricity: null,
        natural_gas: null,
        propane: null,
        fuel_oil: null,
        occupants: null,
        distance: null,
        mpg: null,
        project: ''
    },
    mutations: {
        setElectricity(state, data) { state.electricity = data; },
        setNaturalGas(state, data) { state.natural_gas = data; },
        setPropane(state, data) { state.propane = data; },
        setFuelOil(state, data) { state.fuel_oil = data; },
        setOccupants(state, data) { state.occupants = data; },
        setDistance(state, data) { state.distance = data; },
        setMpg(state, data) { state.mpg = data; },
        setProject(state, data) { state.project = data; },
        reset(state, data) {
            state.electricity = null;
            state.natural_gas = null;
            state.propane = null;
            state.fuel_oil = null;
            state.occupants = null;
            state.distance = null;
            state.mpg = null;
            state.project = "";
        }
    },
    getters: {
        isset: function(state) {
            return state.electricity != null && state.natural_gas != null && state.fuel_oil != null && state.occupants != null && state.distance != null && state.mpg != null;
        },
        electricity(state) {
            return state.electricity;
        },
        electricity_co2(state) {
            return state.electricity * 0.000707; // 0.000707 = MT/kWh
        },
        natural_gas(state) {
            return state.natural_gas;
        },
        natural_gas_co2(state) {
            return state.natural_gas * 0.005311; // 0.005311 = MT/therm
        },
        propane(state) {
            return state.propane;
        },
        propane_co2(state) {
            return state.propane * 0.005911; // MT/gallon of propane
        },
        fuel_oil(state) {
            return state.fuel_oil;
        },
        fuel_oil_co2(state) {
            return state.fuel_oil * 0.01024098; // 0.0106305825 = MT/gallon. Only considering the usage of Fuel Oil #2
        },
        occupants(state) {
            return state.occupants;
        },
        occupants_co2(state) {
            return state.occupants * 0.3138858662; // 692 (lbs CO2 per year per occupant) / 2204.623 (conversion from lbs to MT)
        },
        distance(state) {
            return state.distance;
        },
        mpg(state) {
            return state.mpg;
        },
        vehicle_co2(state) {
            return state.distance / state.mpg * 0.00887; // 0.00887 = MT/gallon
        },
        total_mt_co2(state, getters) {
            return getters.electricity_co2 + getters.natural_gas_co2 + getters.propane_co2 + getters.fuel_oil_co2 + getters.occupants_co2 + getters.vehicle_co2;
        },
        total_lbs_co2(state, getters) {
            return getters.total_mt_co2 * 2204.623;
        },
        trees(state, getters) {
            return getters.total_mt_co2 * 16.535211733386;
        },
        project(state) {
            console.log(state);
            return state.project;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/generallivingformdata.js